var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"snz-stat-label",class:{ dark: _vm.dark }},[_c('div',{staticClass:"snz-stat-label_value"},[_vm._t("default",function(){return [_vm._v("_ _")]})],2),_c('div',{staticClass:"snz-stat-label_label snz-txt-caption"},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }